export const TAB_KEYS = {
  PRODUCTS: 'products',
  BUNDLES: 'bundles',
  MEMBERS: 'members',
  DELIVERY_RETURN: 'delivery-return',
  DOCUMENTS: 'documents',
  HISTORY: 'history',
  FEES: 'fees',
  LINKED_ITEMS: 'linked-items',
  PAYMENT_BILLING: 'payment-billing',
};

export const SUBSCRIPTION_TABS = [
  {
    label: 'Products',
    key: TAB_KEYS.PRODUCTS,
    id: TAB_KEYS.PRODUCTS,
  },
  {
    label: 'Bundles',
    key: TAB_KEYS.BUNDLES,
    id: TAB_KEYS.BUNDLES,
  },
  {
    label: 'Members',
    key: TAB_KEYS.MEMBERS,
    id: TAB_KEYS.MEMBERS,
  },
  {
    label: 'Delivery/Return',
    key: TAB_KEYS.DELIVERY_RETURN,
    id: TAB_KEYS.DELIVERY_RETURN,
  },
  {
    label: 'Documents',
    key: TAB_KEYS.DOCUMENTS,
    id: TAB_KEYS.DOCUMENTS,
  },
  {
    label: 'History',
    key: TAB_KEYS.HISTORY,
    id: TAB_KEYS.HISTORY,
  },
  {
    label: 'Fees',
    key: TAB_KEYS.FEES,
    id: TAB_KEYS.FEES,
  },
  {
    label: 'Linked items',
    key: TAB_KEYS.LINKED_ITEMS,
    id: TAB_KEYS.LINKED_ITEMS,
  },
  {
    label: 'Payment & Billing',
    key: TAB_KEYS.PAYMENT_BILLING,
    id: TAB_KEYS.PAYMENT_BILLING,
  },
];
